import type { TrackOptions } from "@/lib/analytics";
import { ctaEventForLink } from "@/lib/ctaEvents";

/**
 * Fire-and-forget event tracking for code in the main bundle.
 *
 * `@/lib/analytics` pulls in posthog-js, which is kept out of the main bundle
 * by only ever importing it dynamically (see `src/App.tsx`). App loads that
 * chunk on mount, so by the time anyone clicks anything this resolves from the
 * module cache. `trackEvent` is a no-op until analytics consent is given.
 *
 * Event names are snake_case. Never pass email addresses or free-text field
 * values as properties.
 */
export function track(event: string, properties?: Record<string, unknown>, options?: TrackOptions) {
  import("@/lib/analytics")
    .then(({ trackEvent }) => trackEvent(event, properties, options))
    .catch(() => {
      // Analytics failing to load must never break the interaction it measures.
    });
}

/**
 * For the few CTAs that are buttons navigating in code rather than links.
 * Real `<a>` / `<Link>` CTAs need nothing: `CtaClickTracker` sees them.
 */
export function trackCtaNavigation(href: string, placement?: string) {
  const cta = ctaEventForLink({ href, placement }, window.location);
  if (cta) track(cta.event, cta.properties, { beacon: cta.leavesPage });
}
